import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import routes, {type RouteConfig} from '../routes';

const AuthLayout = () => {
  const getRoutes = (routes: RouteConfig[]) => {
    return routes
      .filter((route) => route.layout === '/admin/auth')
      .map((route, key) => <Route path={route.path} element={<route.component />} key={key} />);
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<Navigate to="/admin/auth/login-page" replace />} />
      </Routes>
    </div>
  );
};

export default AuthLayout;
